function countUpMessagecard() {
  return [...document.querySelectorAll('tr.cart-item')].reduce(
    (acc, tr) =>{
      const name = tr.querySelector('.cart-item__name').textContent;
      if (name==='メッセージカード') {
        return acc+parseInt(tr.querySelector('.quantity__input').value);
      } else {
        return acc;
      }
    },
    0
  )
}

function countUpProduct() {
  return [...document.querySelectorAll('tr.cart-item')].reduce(
    (acc, tr) =>{
      const name = tr.querySelector('.cart-item__name').textContent;
      if (name!=='メッセージカード' && name!=='日付指定配送') {
        return acc+parseInt(tr.querySelector('.quantity__input').value);
      } else {
        return acc;
      }
    },
    0
  )
}

function countUpFreezeDeliveryProduct() {
  return [...document.querySelectorAll('tr.cart-item')].reduce(
    (acc, tr) =>{
      const name = tr.querySelector('.cart-item__name').textContent;
      if (name.match(/冷凍配送/)) {
        return acc+parseInt(tr.querySelector('.quantity__input').value);
      } else {
        return acc;
      }
    },
    0
  )
}

function cloneAGButton() {
  const button = document.querySelector('.anygift-cart-e-gift-modal__open-button');
  const newButton = button.cloneNode(true);
  newButton.classList.remove('anygift-cart-e-gift-modal__open-button');
  newButton.classList.add('anygift-cart-e-gift-modal__open-button-cloned')
  newButton.classList.add('button');
  button.before(newButton);
  newButton.addEventListener('click', showAGDialog);
}

function showAGDialog() {
  document.getElementById('ag-dialog')?.showModal();
}

function checkoutValidation() {
  const checkoutButton = document.getElementById('checkout');
  const messagecardCount = countUpMessagecard();
  const productCount = countUpProduct();
  const freezeDeliveryProductCount = countUpFreezeDeliveryProduct();
  console.log("メッセージカード数:",messagecardCount,"商品数:",productCount, "冷凍配送品:", freezeDeliveryProductCount);
  const msg = messagecardCount > 0 && productCount === 0
              ? ["メッセージカードのみのご購入はできません", "商品をメッセージカードの数量以上ご注文下さい"]
            : messagecardCount > productCount 
              ? ["メッセージカードは商品の数量以上にご注文できません", "メッセージカードを減らすか、商品を足してください"]
            : productCount > freezeDeliveryProductCount && freezeDeliveryProductCount > 0
              ? ["温度帯の違う商品は混載できません", "冷凍配送商品と常温配送商品を混ぜて発送することはできません。<br>お手数ですが、冷凍のみか常温のみにして下さい。"]
            : [];
  console.log(msg);
  if (msg.length === 0) {
    console.log('remove');
    checkoutButton.removeAttribute('disabled');
  } else {
    console.log('set');
    checkoutButton.setAttribute('disabled', true);
  }
  if (document.getElementById('checkout-button-disabled-message') === null) {
    const div = document.createElement('div');
    div.style.display = 'none';
    div.id = 'checkout-button-disabled-message';
    document.getElementById('checkout').parentElement.before(div);
  }

  const divA = document.getElementById('checkout-button-disabled-message');
  divA.innerHTML = `<h3>${msg[0]}</h3><div>${msg[1]}</div>`;
  divA.style.display = msg.length > 0 ? 'block' : 'none';

  const divB = document.getElementById('bzn-cart-check-errormsg');
  divB.innerHTML = `<h3>${msg[0]}</h3><div>${msg[1]}</div>`;
  divB.style.display = msg.length > 0 ? 'block' : 'none';
}

[... document.querySelectorAll('.quantity__input')].forEach(f=>{
  f.addEventListener('change', checkoutValidation);
})

checkoutValidation();